module.exports = __webpack_public_path__ + "img/wxcode.793ac576.png";